<app-modal id="add-book-form" [maskClose]="false">
  <aside class="modal">
    <div class="modal-body" id="add-book-form-body">
      <div class="header">
        <div class="title-text">Add a Book</div>
        @if (!inProgress) {
          <div class="button regular close cancel-add-book" (click)="cancel()"><span
          class="icon">&#x00D7;</span></div>
        }
      </div>
      <hr />
      @if (!amazonInProgress && !withAmazon && !withOutAmazon) {
        <div class="imgUplad">
          <img src="/assets/img/upload.png" />
          <h2 class="strong3">Adding a book is easy, let’s start with an Amazon link</h2>
        </div>
      }
      @if (form) {
        <form [formGroup]="form" (submit)="save($event)">
          @if (showContent) {
            <div class="content">
              @if (amazonError) {
                <div class="amazon-error">
                  <div class="amazon-text-wrapper">
                    <h4 class="amazon-error-text">Amazon Error!</h4>
                    <p class="amazon-error-text">We’re sorry, it appears that Amazon’s book pulling technology is currently
                      not working. Don't worry! Simply complete the form fields below to add your book. You will need to
                    manually upload your book cover image.</p>
                  </div>
                  <div class="amazon-error-close">
                    <div class="button amazon close" (click)="dismissAmazonError()"><span class="icon close">&#x00D7;</span>
                  </div>
                </div>
              </div>
            }
            @if (inProgress && !showForm2) {
              <app-spinner></app-spinner>
            }
            @if (showForm2) {
              <div>
                @if (inProgress || amazonInProgress) {
                  <div class="loading">
                    <app-spinner label="Loading from: {{form.value.amazonLink}}"></app-spinner>
                  </div>
                }
                @if (!withOutAmazon && !amazonInProgress && !withAmazon) {
                  <div class="book-info">
                    <div class="details">
                      <app-form-input [input]="formComponents.amazonLink" [form]="form" (blurHappened)="checkScraping()"
                      (keydown)="handleKeyDown($event)"></app-form-input>
                    </div>
                  </div>
                }
                @if (withAmazon && !withOutAmazon && !amazonInProgress) {
                  <div class="book-info">
                    <div class="cover">
                      <app-file-drop
                        [bookUrl]="book.amazonImageUrl ? book.amazonImageUrl : '/assets/img/defaults/default_book_image_400w_simple.jpg'"
                        (loading)="isUploadingBookCover($event)" (bookUploadData)="bookCoverUpload($event)"
                        (bookUploadError)="bookCoverUploadError($event)">
                      </app-file-drop>
                    </div>
                    <div class="details">
                      <app-form-input [input]="formComponents.title" [form]="form"></app-form-input>
                      <app-form-input [input]="formComponents.author" [form]="form"></app-form-input>
                      <app-form-input [input]="formComponents.description" [form]="form"></app-form-input>
                      @if (form.controls['description'].value) {
                        <div class="description-counter"
                          [ngClass]="{'alert': form.controls['description'].value.length > 350}">
                        {{form.controls['description'].value.length}} characters</div>
                      }
                      <p>Must be 350 characters or less. Please don't copy from Amazon.</p>
                    </div>
                  </div>
                }
                @if (withOutAmazon) {
                  <div class="book-info">
                    <div class="cover">
                      <app-file-drop
                        [bookUrl]="book.amazonImageUrl ? book.amazonImageUrl : '/assets/img/defaults/default_book_image_400w_simple.jpg'"
                        (loading)="isUploadingBookCover($event)" (bookUploadData)="bookCoverUpload($event)"
                        (bookUploadError)="bookCoverUploadError($event)">
                      </app-file-drop>
                    </div>
                    <div class="details">
                      <app-form-input [input]="formComponents.title" [form]="form"></app-form-input>
                      <app-form-input [input]="formComponents.author" [form]="form"></app-form-input>
                      <app-form-input [input]="formComponents.description" [form]="form"></app-form-input>
                      @if (form.controls['description'].value) {
                        <div class="description-counter"
                          [ngClass]="{'alert': form.controls['description'].value.length > 350}">
                        {{form.controls['description'].value.length}} characters</div>
                      }
                      <p>Must be 350 characters or less. Please don't copy from Amazon.</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (!showContent) {
          <div class="content">
            @if (inProgress) {
              <div>
                <app-spinner label="Saving"></app-spinner>
              </div>
            }
            @if (!inProgress) {
              <div class="outer">
                @if (otherBooks.length > 0) {
                  <div>
                    <p class="successfully">We've added your book, <strong>{{this.book.title}}</strong>, successfully.</p>
                    <p>We detected @if (otherBooks.length > 1) {
                      <span>that a few other books</span>
                      }@if (otherBooks.length === 1) {
                      <span
                      >another book that</span>
                      } might be yours, would you like to add @if (otherBooks.length > 1) {
                      <span
                      >them</span>
                      }@if (otherBooks.length === 1) {
                      <span>it</span>
                    } now?</p>
                    <div class="book-container">
                      <div class="book">
                        <div class="image">
                          <img class="img1" [@fadeOut1]="showImg1" [@fadeIn1]="showImg1"
                            [src]="otherBooks[currentIndex].amazonImageUrl" />
                          <img class="img2" [@fadeOut2]="showImg2" [@fadeIn2]="showImg2" [src]="backgroundImage" />
                        </div>
                        @if (showButtons) {
                          <div class="button-container">
                            @if (!otherBooks[currentIndex].added) {
                              <div class="book-button button" (click)="addOtherBook()">
                              Yes, add it to my Books</div>
                            }
                            @if (!otherBooks[currentIndex].added) {
                              <div class="book-button alert button"
                              (click)="skipOtherBook()">This is not my book.</div>
                            }
                            @if (otherBooks[currentIndex].added) {
                              <div class="book-button green">Book Added</div>
                            }
                            <div class="book-button blue button" (click)="saveOtherBooks()">I'm All Done</div>
                            <div class="counter">{{currentIndex + 1}} of {{otherBooks.length}}</div>
                          </div>
                        }
                        <div class="nav">
                          @if (currentIndex > 0) {
                            <div class="button nav icon left" (click)="changeOtherBook(-1)">&#xf3cf;
                            </div>
                          }
                          @if (currentIndex + 1 < otherBooks.length) {
                            <div class="button nav icon right"
                            (click)="changeOtherBook(1)">&#xf3d1;</div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (otherBooks.length === 0) {
                  <div class="single-book-added-container">
                    <p class="successfully">We've added your book, <strong>{{this.book.title}}</strong>, successfully.</p>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (!showContent && otherBooks.length === 0) {
          <div class="footer">
            <div style="text-align: right"><button type="button" class="regular button solid-green" (click)="cancel()">OK</button>
          </div>
        </div>
      }
      @if (showContent) {
        <div class="footer">
          <div style="display: inline-flex;">
            @if (withAmazon || withOutAmazon || amazonInProgress) {
              <div class="button regular outline-grey cancel-add-book"
              (click)="cancel()">Cancel</div>
            }
            @if (showForm1) {
              <button type="button" class="button regular solid-green submit-add-book"
              (click)="checkScraping()">Add Book</button>
            }
            @if (!withOutAmazon && !amazonInProgress && !withAmazon && !showForm1) {
              <button type="button" class="button regular solid-green submit-add-book"
                (click)="scrapeLink()">Add
              Book</button>
            }
            @if (form && form.valid) {
              <button type="submit" class="button regular solid-green submit-add-book">Add
              Book</button>
            }
            @if (!form || !form.valid) {
              <div></div>
            }
          </div>
          @if (!withAmazon && !amazonInProgress && !withOutAmazon) {
            <a (click)="noAmazon()">
              Proceed without an Amazon link
            </a>
          }
          @if (withOutAmazon) {
            <a (click)="Amazon()">
              Proceed with an Amazon link
            </a>
          }
        </div>
      }
    </form>
  }
</div>
</aside>
<div class="modal-background"></div>
</app-modal>
<app-confirm-modal [modalId]="'ab-confirm-modal'" [text]="confirmText" [buttonText]="buttonText"
(confirmChoice)="handleConfirm($event)"></app-confirm-modal>
<!-- <app-error-modal [modalId]="'ab-error-modal'" [text]="errorText"></app-error-modal> -->
<app-new-error-modal modalId="ab-error-modal" [options]="errorOptions"></app-new-error-modal>
